import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IDatabase } from '../types/IDatabase';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import {
  IMaxDownstreamDatasources,
  IMaxDownstreamWorkbooks
} from '../types/IMaxDownstreamConnections';
import { forceIsEmbeddedToFalse } from '../utils/CrassRequestHelper';

export interface IGetDatabasesParams extends IGetItemsParams {}

export interface IGetDatabasesResult extends IGetItemsResult {
  databases?: IDatabase[];
  maxDownstreamDatasourcesViewModel?: IMaxDownstreamDatasources;
  maxDownstreamWorkbooksViewModel?: IMaxDownstreamWorkbooks;
}

export class GetDatabasesRequest extends Request<
  IGetDatabasesParams,
  IGetDatabasesResult
> {
  constructor(params: IGetDatabasesParams) {
    // force isEmbedded to false as a workaround for
    // Defect 1214943: CRASS: Embedded Assets: inconsistent database/table count and content to due insufficient permission

    super('getDatabases', forceIsEmbeddedToFalse(params));
  }
}

